/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 账户信息
 */
import { AddressController } from './address';
import { BusinessController } from './business';
import { CustomerController } from './customer';
import { DownloadController } from './download';
import { EnterpriseController } from './enterprise';
import { ExamineController } from './examine';
import { IntegralController } from './integral';
import { InviteController } from './invite';
import { ISGAddressController } from './isgAddress';
import { MyCodeController } from './myCode';
import { NoticeController } from './notification';
export class AccountController {
  /** @dec 地址管理 */
  AddressController = new AddressController();
  /** @dec ISG地址管理 */
  ISGAddressController = new ISGAddressController();
  /** @dec 积分 */
  IntegralController = new IntegralController();
  /** @dec 商机 */
  BusinessController = new BusinessController();
  /** @dec 企业认证 */
  EnterpriseController = new EnterpriseController();
  /** @dec 我区域的客户 */
  CustomerController = new CustomerController();
  /** @dec 我的邀请记录 */
  InviteController = new InviteController();
  /** @dec 我的二维码 */
  MyCodeController = new MyCodeController();
  /** @dec 我的下载 */
  DownloadController = new DownloadController();
  /** @desc 消息提醒 */
  NotificationController = new NoticeController();
  /** @desc 我的审批 */
  ExamineController = new ExamineController();
}
